// extracted by mini-css-extract-plugin
export default {"fontSize":"ButtonTextAlignment_fontSize__pNMEk","dropdown":"ButtonTextAlignment_dropdown__TDlf3","alignmentButtons":"ButtonTextAlignment_alignmentButtons__s0mOe"};